var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 865,
    height: 662,
    viewBox: "0 0 865 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3525_1745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1096,
    height: 822
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 8C136.5 3.85786 133.142 0.5 129 0.5H64C28.9299 0.5 0.5 28.9299 0.5 64V129C0.5 133.142 3.85786 136.5 8 136.5H129C133.142 136.5 136.5 133.142 136.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 8C137.5 3.85786 140.858 0.5 145 0.5H210C245.07 0.5 273.5 28.9299 273.5 64V129C273.5 133.142 270.142 136.5 266 136.5H145C140.858 136.5 137.5 133.142 137.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 266C137.5 270.142 140.858 273.5 145 273.5H210C245.07 273.5 273.5 245.07 273.5 210V145C273.5 140.858 270.142 137.5 266 137.5H145C140.858 137.5 137.5 140.858 137.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 266C136.5 270.142 133.142 273.5 129 273.5H64C28.9299 273.5 0.5 245.07 0.5 210V145C0.5 140.858 3.85786 137.5 8 137.5H129C133.142 137.5 136.5 140.858 136.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 282C136.5 277.858 133.142 274.5 129 274.5H64C28.9299 274.5 0.5 302.93 0.5 338V403C0.5 407.142 3.85786 410.5 8 410.5H129C133.142 410.5 136.5 407.142 136.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 282C137.5 277.858 140.858 274.5 145 274.5H210C245.07 274.5 273.5 302.93 273.5 338V403C273.5 407.142 270.142 410.5 266 410.5H145C140.858 410.5 137.5 407.142 137.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 540C137.5 544.142 140.858 547.5 145 547.5H210C245.07 547.5 273.5 519.07 273.5 484V419C273.5 414.858 270.142 411.5 266 411.5H145C140.858 411.5 137.5 414.858 137.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 540C136.5 544.142 133.142 547.5 129 547.5H64C28.9299 547.5 0.5 519.07 0.5 484V419C0.5 414.858 3.85786 411.5 8 411.5H129C133.142 411.5 136.5 414.858 136.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 556C136.5 551.858 133.142 548.5 129 548.5H64C28.9299 548.5 0.5 576.93 0.5 612V677C0.5 681.142 3.85786 684.5 8 684.5H129C133.142 684.5 136.5 681.142 136.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 556C137.5 551.858 140.858 548.5 145 548.5H210C245.07 548.5 273.5 576.93 273.5 612V677C273.5 681.142 270.142 684.5 266 684.5H145C140.858 684.5 137.5 681.142 137.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 8C410.5 3.85786 407.142 0.5 403 0.5H338C302.93 0.5 274.5 28.9299 274.5 64V129C274.5 133.142 277.858 136.5 282 136.5H403C407.142 136.5 410.5 133.142 410.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 8C411.5 3.85786 414.858 0.5 419 0.5H484C519.07 0.5 547.5 28.9299 547.5 64V129C547.5 133.142 544.142 136.5 540 136.5H419C414.858 136.5 411.5 133.142 411.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 266C411.5 270.142 414.858 273.5 419 273.5H484C519.07 273.5 547.5 245.07 547.5 210V145C547.5 140.858 544.142 137.5 540 137.5H419C414.858 137.5 411.5 140.858 411.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 266C410.5 270.142 407.142 273.5 403 273.5H338C302.93 273.5 274.5 245.07 274.5 210V145C274.5 140.858 277.858 137.5 282 137.5H403C407.142 137.5 410.5 140.858 410.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 282C410.5 277.858 407.142 274.5 403 274.5H338C302.93 274.5 274.5 302.93 274.5 338V403C274.5 407.142 277.858 410.5 282 410.5H403C407.142 410.5 410.5 407.142 410.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 282C411.5 277.858 414.858 274.5 419 274.5H484C519.07 274.5 547.5 302.93 547.5 338V403C547.5 407.142 544.142 410.5 540 410.5H419C414.858 410.5 411.5 407.142 411.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 540C411.5 544.142 414.858 547.5 419 547.5H484C519.07 547.5 547.5 519.07 547.5 484V419C547.5 414.858 544.142 411.5 540 411.5H419C414.858 411.5 411.5 414.858 411.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 540C410.5 544.142 407.142 547.5 403 547.5H338C302.93 547.5 274.5 519.07 274.5 484V419C274.5 414.858 277.858 411.5 282 411.5H403C407.142 411.5 410.5 414.858 410.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 556C410.5 551.858 407.142 548.5 403 548.5H338C302.93 548.5 274.5 576.93 274.5 612V677C274.5 681.142 277.858 684.5 282 684.5H403C407.142 684.5 410.5 681.142 410.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M411.5 556C411.5 551.858 414.858 548.5 419 548.5H484C519.07 548.5 547.5 576.93 547.5 612V677C547.5 681.142 544.142 684.5 540 684.5H419C414.858 684.5 411.5 681.142 411.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 8C684.5 3.85786 681.142 0.5 677 0.5H612C576.93 0.5 548.5 28.9299 548.5 64V129C548.5 133.142 551.858 136.5 556 136.5H677C681.142 136.5 684.5 133.142 684.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 8C685.5 3.85786 688.858 0.5 693 0.5H758C793.07 0.5 821.5 28.9299 821.5 64V129C821.5 133.142 818.142 136.5 814 136.5H693C688.858 136.5 685.5 133.142 685.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 266C685.5 270.142 688.858 273.5 693 273.5H758C793.07 273.5 821.5 245.07 821.5 210V145C821.5 140.858 818.142 137.5 814 137.5H693C688.858 137.5 685.5 140.858 685.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 266C684.5 270.142 681.142 273.5 677 273.5H612C576.93 273.5 548.5 245.07 548.5 210V145C548.5 140.858 551.858 137.5 556 137.5H677C681.142 137.5 684.5 140.858 684.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 282C684.5 277.858 681.142 274.5 677 274.5H612C576.93 274.5 548.5 302.93 548.5 338V403C548.5 407.142 551.858 410.5 556 410.5H677C681.142 410.5 684.5 407.142 684.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 282C685.5 277.858 688.858 274.5 693 274.5H758C793.07 274.5 821.5 302.93 821.5 338V403C821.5 407.142 818.142 410.5 814 410.5H693C688.858 410.5 685.5 407.142 685.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 540C685.5 544.142 688.858 547.5 693 547.5H758C793.07 547.5 821.5 519.07 821.5 484V419C821.5 414.858 818.142 411.5 814 411.5H693C688.858 411.5 685.5 414.858 685.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 540C684.5 544.142 681.142 547.5 677 547.5H612C576.93 547.5 548.5 519.07 548.5 484V419C548.5 414.858 551.858 411.5 556 411.5H677C681.142 411.5 684.5 414.858 684.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 556C684.5 551.858 681.142 548.5 677 548.5H612C576.93 548.5 548.5 576.93 548.5 612V677C548.5 681.142 551.858 684.5 556 684.5H677C681.142 684.5 684.5 681.142 684.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 556C685.5 551.858 688.858 548.5 693 548.5H758C793.07 548.5 821.5 576.93 821.5 612V677C821.5 681.142 818.142 684.5 814 684.5H693C688.858 684.5 685.5 681.142 685.5 677V556Z",
    stroke: "#DEDEDE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5 8C958.5 3.85786 955.142 0.5 951 0.5H886C850.93 0.5 822.5 28.9299 822.5 64V129C822.5 133.142 825.858 136.5 830 136.5H951C955.142 136.5 958.5 133.142 958.5 129V8Z",
    stroke: "#DEDEDE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5 266C958.5 270.142 955.142 273.5 951 273.5H886C850.93 273.5 822.5 245.07 822.5 210V145C822.5 140.858 825.858 137.5 830 137.5H951C955.142 137.5 958.5 140.858 958.5 145V266Z",
    stroke: "#DEDEDE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5 282C958.5 277.858 955.142 274.5 951 274.5H886C850.93 274.5 822.5 302.93 822.5 338V403C822.5 407.142 825.858 410.5 830 410.5H951C955.142 410.5 958.5 407.142 958.5 403V282Z",
    stroke: "#DEDEDE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5 540C958.5 544.142 955.142 547.5 951 547.5H886C850.93 547.5 822.5 519.07 822.5 484V419C822.5 414.858 825.858 411.5 830 411.5H951C955.142 411.5 958.5 414.858 958.5 419V540Z",
    stroke: "#DEDEDE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5 556C958.5 551.858 955.142 548.5 951 548.5H886C850.93 548.5 822.5 576.93 822.5 612V677C822.5 681.142 825.858 684.5 830 684.5H951C955.142 684.5 958.5 681.142 958.5 677V556Z",
    stroke: "#DEDEDE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3525_1745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -117.754,
    y: -191.553,
    width: 982.188,
    height: 1141.03,
    fill: "url(#paint0_radial_3525_1745)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3525_1745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(373.34 378.96) rotate(90) scale(570.513 491.094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridMask);
export default __webpack_public_path__ + "static/media/gridMask.63bc2d692a5ca316047ae7991fdb5d73.svg";
export { ForwardRef as ReactComponent };